import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, select } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/types';
import { amlbotAPI } from '@/api';
import type {
  AmlHistoryRequest,
  AmlHistoryResponse,
  ExploreConnectionRequest,
  ExploreConnectionResponse,
} from '@/api';
import { parseError } from '@/redux/helpers';
import { investigationHistoryActions } from '../../actions';
import { investigationHistoryMappers } from '../../mappers';
import { replace } from 'redux-first-history';

function* fetchInvestigationHistory(
  action: PayloadAction<AmlHistoryRequest>,
): SagaIterator {
  try {
    const { payload } = action;

    payload.filterType = true;
    const response: AmlHistoryResponse = yield call(
      amlbotAPI.fetchAmlHistory,
      payload,
    );
    const data = investigationHistoryMappers.investigationHistory(response);

    const isShowMoreRequest = 'page' in payload;

    if (isShowMoreRequest) {
      yield put(investigationHistoryActions.addData(data));
    } else {
      yield put(investigationHistoryActions.setData(data));
    }
  } catch (error: unknown) {
    const { message } = parseError(error);
    yield put(investigationHistoryActions.setError(message));
  } finally {
    yield put(investigationHistoryActions.setLoading(false));
  }
}

function* exploreConnection(
  action: PayloadAction<ExploreConnectionRequest>,
): SagaIterator {
  try {
    const { payload } = action;

    const response: ExploreConnectionResponse = yield call(
      amlbotAPI.exploreConnection,
      payload,
    );
    const data =
      investigationHistoryMappers.handleInvestigationHistoryItem(response);
    yield put(investigationHistoryActions.updateItem(data));

    const location: Location = yield select((state) => state.router.location);
    yield put(
      replace(location.pathname + location.search, { extendedItem: data }),
    );
  } catch (error: unknown) {
    const { message, errorCode } = parseError(error);
    // Optionally handle errorCode - ErrorCodeEnum.FIELD_REQUIRED
    yield put(investigationHistoryActions.setError(message));
  } finally {
    yield put(investigationHistoryActions.setLoading(false));
  }
}

export { fetchInvestigationHistory, exploreConnection };
